const SESSION_STORAGE_KEY = "inkredible_retail_v1";

export function addToList(product) {
  // Get saved data from sessionStorage
  const currentList = getList();
  const item = product[Object.keys(product)[0]];
  const listSku = Object.keys(product)[0];

  if (currentList) {
    const isAlreadythere = currentList[listSku] ? true : false;
    if (isAlreadythere) {
      currentList[listSku].quantity =
        parseInt(currentList[listSku].quantity, 10) +
        parseInt(item.quantity, 10);
      setList(currentList);
    } else {
      setList(Object.assign({}, currentList, product));
    }
  } else {
    setList(product);
  }
}

export function getList() {
  const sessionKey = `${SESSION_STORAGE_KEY}_wishlist`;
  return JSON.parse(window.sessionStorage.getItem(sessionKey));
}

export function noOfItemsInList() {
  const list = getList() || {};
  const noOfitems = Object.keys(list).length;
  return `Wishlist (${noOfitems} Items)`;
}

function setList(item) {
  const sessionKey = `${SESSION_STORAGE_KEY}_wishlist`;
  return sessionStorage.setItem(sessionKey, JSON.stringify(item));
}
